import { lazy, Suspense } from 'react';
import LoadingCom from '../../../components/LoadingCom';
import PageErrorBoundary from '../../../components/PageErrorBoundary';

const Step3 = lazy(() => import('./Index'));

export default function SuspendedStep3SetupPage(props: any) {
  return (
    <PageErrorBoundary>
      <Suspense fallback={<LoadingCom />}>
        <Step3 {...props} />
      </Suspense>
    </PageErrorBoundary>
  );
}
